import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  TrackByFunction,
  ViewEncapsulation
} from '@angular/core';
import { merge, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { MessageConversation } from 'common/store/genesys-cloud/conversations/messages/models/message-conversation.model';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { selectActiveMessageConversations } from 'common/store/genesys-cloud/conversations/messages/selectors/message-conversation.selectors';
import { taskItemAnimation } from 'components/accordion/workitem-list/shared/animations/task-item.animation';

@Component({
  selector: 'app-work-item-genesys-chat-list',
  templateUrl: './workitem-genesys-chat-list.component.html',
  styleUrls: ['./workitem-genesys-chat-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [taskItemAnimation]
})
export class WorkItemGenesysChatListComponent implements OnDestroy {
  @Input()
  isHybrid: boolean;
  private readonly onDestroySubject = new Subject<void>();
  private readonly workItemChanges$ = merge(
    this.workItemStateHandler.workItemFocused$,
    this.workItemStateHandler.openedWorkItemsChanged$
  ).pipe(
    debounceTime(0),
    takeUntil(this.onDestroySubject)
  );
  readonly conversations$ = this.store.select(selectActiveMessageConversations);
  readonly conversationCount$ = this.conversations$.pipe(map(conversations => conversations.length));

  constructor(readonly store: Store,
              private readonly changeDetectorRef: ChangeDetectorRef,
              private readonly workItemStateHandler: WorkItemStateHandler
  ) {
    this.workItemChanges$.subscribe(() => this.changeDetectorRef.detectChanges());
  }

  readonly conversationTrackByFn: TrackByFunction<MessageConversation> = (_, conversation) => conversation?.id;

  ngOnDestroy(): void {
    this.onDestroySubject.next();
    this.onDestroySubject.complete();
  }

  isOpened(conversationId: string): boolean {
    return this.workItemStateHandler.isOpened(conversationId);
  }

  isFocused(conversationId: string): boolean {
    return this.workItemStateHandler.isFocused(conversationId);
  }
}
